<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_2">Dedication</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">To my beautiful wife:</p>
<p class="block_5"> </p>
<p class="block_6">You are the constant and clear inspiration for all that I do. The greatest times in my life all have one thing in common: you. </p>
<p class="block_5"> </p>
<p class="block_6">I wholeheartedly believe that the human spirit is a beautiful thing and I have encountered none more beautiful than yours. You are as wise as you are lovely. As gentle as you are patient. The immovable object beneath our feet, keeping us strong and ready.</p>
<p class="block_5"> </p>
<p class="block_6">I write this dedication having just found out that I will be a father. You, little one, are only the size of a poppy seed, yet you are the greatest thing in this entire world. I love you.</p>
<p class="block_5"> </p>
<p class="block_2">To my mother and father:</p>
<p class="block_5"> </p>
<p class="block_6">You have unselfishly given the best of yourselves so that I can give the best of me.</p>
<p class="block_5"> </p>
<p class="block_6">My mother, one of the few people I have ever known with enough love in her to share with her family, as well as the world around her. She helped everyone she could and never asked for anything in return.</p>
<p class="block_5"> </p>
<p class="block_6">My father, one of the most talented and wisest men I will ever know.</p>
<p class="block_5"> </p>
<p class="block_6">You three have shown me a world that does not exist in the here and now.</p>
<p class="block_5"> </p>
<p class="block_6">You have helped show me a better one.</p>
<p class="block_5"> </p>
<p class="block_6">I love you, Mom and Pop</p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_7"> </p>
<p class="block_2">To my brother:</p>
<p class="block_5"> </p>
<p class="block_6">You were where it all began. You are the greatest artist I have ever known.</p>
<p class="block_5"> </p>
<p class="block_6">From childhood you held my hand and walked me into a world of possibilities.</p>
<p class="block_5"> </p>
<p class="block_6">From our favourite cartoons to our first home console (Nintendo), we travelled to places many will never see and created places many will never go.</p>
<p class="block_5"> </p>
<p class="block_6">I hope this book does the memory of our childhood proud.</p>
<p class="block_5"> </p>
<p class="block_6">Love you, Big Bro!</p>
<p class="block_5"> </p>
<p class="block_2">To my in-laws:</p>
<p class="block_5"> </p>
<p class="block_6">I am beyond fortunate to say that I have been blessed with a familial extension that is unlike any other.</p>
<p class="block_8"> </p>
<p class="block_2">To my beautiful son:</p>
<p class="block_5"> </p>
<p class="block_6">I wrote this long before you were born and now, I am a few short months from celebrating your 3<sup class="calibre1">rd</sup> birthday. You, my baby boy, are the light in every dark room. You are the breeze on every hot day and the peace during every storm. </p>
<p class="block_5"> </p>
<p class="block_6">When you smile, I see your mother and when you cry, I am broken.</p>
<p class="block_6">Your hands are small, yet somehow, they have rearranged the stars. Your feet so little, yet where they go, I am sure to follow.</p>
<p class="block_5"> </p>
<p class="block_6">Through every season in life know this:</p>
<p class="block_9"><span class="text_">You, my precious boy, always made me proud.</span><span class="text_1"><br class="calibre2" id="calibre_pb_1"/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?34918a2a